import { useState } from "react";
import type { AgentMe } from "./api.ts";
import { Voicemail } from "./Voicemail.tsx";
import { History } from "./History.tsx";
import { Greetings } from "./Greetings.tsx";
import { FlowEditor } from "./flow";
import { flowEditorDirty } from "./flow/Editor.tsx";
import { SchedulePage } from "./SchedulePage.tsx";
import { Agents } from "./Agents.tsx";
import { AuditLog } from "./AuditLog.tsx";

type View = "agents" | "history" | "voicemail" | "greetings" | "flow" | "schedule" | "audit";

export function AdminDashboard(props: { me: AgentMe; token: string; onLogout: () => void }) {
  const [view, setView] = useState<View>("agents");

  /** Sidebar navigation with an unsaved-changes guard: leaving the
   *  flow editor unmounts it, so warn if edits would be lost. */
  function nav(next: View): void {
    if (next === view) return;
    if (
      view === "flow" &&
      flowEditorDirty.current &&
      !confirm("Le flux d'appel a des modifications non enregistrées. Quitter et les perdre ?")
    ) {
      return;
    }
    setView(next);
  }

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <h1>Pickit<span className="accent">VoIP Admin</span></h1>
        <nav>
          <button className={view === "agents" ? "active" : ""} onClick={() => nav("agents")}>
            👥 Agents
          </button>
          <button className={view === "history" ? "active" : ""} onClick={() => nav("history")}>
            🕘 Historique
          </button>
          <button className={view === "voicemail" ? "active" : ""} onClick={() => nav("voicemail")}>
            ✉️ Messages vocaux
          </button>
          <button className={view === "greetings" ? "active" : ""} onClick={() => nav("greetings")}>
            📣 Annonces
          </button>
          <button className={view === "flow" ? "active" : ""} onClick={() => nav("flow")}>
            🎚️ Flux d'appel
          </button>
          <button className={view === "schedule" ? "active" : ""} onClick={() => nav("schedule")}>
            📅 Programmation
          </button>
          <button className={view === "audit" ? "active" : ""} onClick={() => nav("audit")}>
            📜 Journal d'audit
          </button>
        </nav>
        <div className="footer">
          <div className="who">{props.me.agent.email}</div>
          <div>{props.me.agent.role === "admin" ? "administrateur" : "agent"}</div>
          <button className="ghost" onClick={props.onLogout} style={{ marginTop: "0.5rem", padding: 0 }}>
            Se déconnecter →
          </button>
        </div>
      </aside>
      <main className="main">
        {view === "agents" && <Agents token={props.token} />}
        {view === "history" && <History token={props.token} />}
        {view === "voicemail" && <Voicemail token={props.token} />}
        {view === "greetings" && <Greetings token={props.token} />}
        {view === "flow" && <FlowEditor token={props.token} />}
        {view === "schedule" && <SchedulePage token={props.token} />}
        {view === "audit" && <AuditLog token={props.token} />}
      </main>
    </div>
  );
}
